/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * CSR format
 */
export enum CsrFormat {
    PEM = 'PEM',
    DER = 'DER',
}
